import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IReboundCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class ReboundCredentialsStore implements ICredentialsStore {
    private _changes: IReboundCredentialsModel = {} as IReboundCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get username() { return this._changes.username; }
    public get orderChannelId() { return this._changes.order_channel_id; }
    public get internalName() { return this._changes.internal_name; }
    public get apiKey() { return this._changes.api_key; }
    public get apiSecret() { return this._changes.api_secret; }
    public get emailAddress() { return this._changes.email_address; }
    public get parcelType() { return this._changes.parcel_type; }
    public get warehouse() { return this._changes.warehouse; }
    public get frontend() { return this._changes.frontend; }

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };
    
    setApiSecret(value: string) {
        this._changes.api_secret = value;
    };

    setOrderChannelId(value: string) {
        this._changes.order_channel_id = value;
    };

    setUsername(value: string) {
        this._changes.username = value;
    };

    setEmailAddress(value: string) { 
        this._changes.email_address = value; 
    };

    setParcelType(value: string) { 
        this._changes.parcel_type = value; 
    };

    setWarehouse(value: string) { 
        this._changes.warehouse = value; 
    };

    setFrontend(value: string) {
        this._changes.frontend = value;
    }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default ReboundCredentialsStore;
